import React from "react";
import { PageHeaderWrapper } from "@ant-design/pro-layout";
import { Card } from "antd";
import EditShipmentForm from "./components/EditShipmentForm";

const EditShipment = () => (
  <PageHeaderWrapper onBack={() => window.history.back()}>
    <Card bordered={false}>
      <EditShipmentForm />
    </Card>
  </PageHeaderWrapper>
);

export default EditShipment;
